import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_TaxService_Dtos_Dashboard_TaxAdminDashboardResponseDto,
} from '../../services/wealthlane-tax-services';

const useGetTaxCustomerDashboardDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_TaxService_Dtos_Dashboard_TaxAdminDashboardResponseDto | undefined,
  unknown
> => {
  const taxCustomerDashboardDetails = useQuery(['getTaxCustomerDashboardDetails'], async () => {
    return await handleRequest(DashboardService.getApiTaxApiAppDashboardAdminDashboard());
  });

  return taxCustomerDashboardDetails;
};

export default useGetTaxCustomerDashboardDetails;
